import Axios from 'axios'
import config from '@/config/config.js'

const baseUrl = config.apiDomain.ALI + '/ext/core-util/public-servant/api/staffTaskReminderEmail/'

Axios.defaults.headers.timeout = 8000

export default {
  getEmailWithTime (cb) {
    Axios.get(baseUrl + 'getEmailWithTime').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  updateEmailWithTime (email, timeTypeId, reminderTypeId, cb) {
    let body = {
      email: email,
      reminderTypeId: reminderTypeId,
      timeTypeId: timeTypeId
    }
    Axios.post(baseUrl + 'updateEmailWithTime', body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  deleteEmail (cb) {
    Axios.delete(baseUrl + 'deleteEmail').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  staffTaskReminderEmailTimeType (cb) {
    Axios.get(baseUrl + 'staffTaskReminderEmailTimeType').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  staffTaskReminderType (cb) {
    Axios.get(baseUrl + 'staffTaskReminderType').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  }

}
